module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "assignments-table"
    }
  }, [(_vm.assignmentData && _vm.columns && _vm.currentTerm) ? _c('v-client-table', {
    ref: "assignmentsTable",
    attrs: {
      "options": _vm.tableOptions,
      "data": _vm.assignmentData,
      "columns": _vm.columns
    },
    scopedSlots: _vm._u([{
      key: "week",
      fn: function(props) {
        return [_c('div', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              _vm.toggleChild(props.row.id)
            }
          }
        }, [_vm._v("\n                Week " + _vm._s(props.row.week) + "\n            ")])]
      }
    }, {
      key: "name",
      fn: function(props) {
        return [_c('div', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              _vm.toggleChild(props.row.id)
            }
          }
        }, [_vm._v("\n                " + _vm._s(props.row.name.substring(0, 24)) + _vm._s(props.row.name.length > 24 ? "..." : "") + "\n            ")])]
      }
    }, {
      key: "courseName",
      fn: function(props) {
        return [(props.row.video) ? _c('div', [_vm._v("\n                " + _vm._s(props.row.video.course.name) + "\n            ")]) : _vm._e()]
      }
    }, {
      key: "dueDate",
      fn: function(props) {
        return [_vm._v("\n            " + _vm._s(_vm._f("localDate")(props.row.dueDate)) + "\n        ")]
      }
    }, {
      key: "submit",
      fn: function(props) {
        return [_c('div', [_c('a', {
          attrs: {
            "href": "#"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              _vm.toggleChild(props.row.id)
            }
          }
        }, [((!props.row.submissions || props.row.submissions.length < 1) &&
          !_vm.isPastDue(props.row.dueDate)) ? _c('span', {
          staticClass: "submit"
        }, [_vm._v("Submit")]) : _vm._e(), _vm._v(" "), ((!props.row.submissions || props.row.submissions.length < 1) &&
          _vm.isPastDue(props.row.dueDate)) ? _c('span', {
          staticClass: "overdue"
        }, [_vm._v("Submit (Past Due)")]) : _vm._e(), _vm._v(" "), (props.row.submissions && props.row.submissions.length > 0 &&
          !_vm.isPastDue(props.row.dueDate)) ? _c('span', {
          staticClass: "resubmit"
        }, [_vm._v("Resubmit")]) : _vm._e(), _vm._v(" "), (props.row.submissions && props.row.submissions.length > 0 &&
          _vm.isPastDue(props.row.dueDate)) ? _c('span', {
          staticClass: "submitted"
        }, [_vm._v("Submitted")]) : _vm._e()])])]
      }
    }, {
      key: "grade",
      fn: function(props) {
        return [(props.row.submissions && props.row.submissions.length > 0 && props.row.submissions[0].grade) ? _c('div', {
          staticClass: "grade"
        }, [_vm._v("\n                " + _vm._s(props.row.submissions[0].grade) + " %\n            ")]) : _vm._e()]
      }
    }, {
      key: "feedback",
      fn: function(props) {
        return [(_vm.assignmentsLoaded) ? _c('div', {
          staticClass: "assignment-play"
        }, [(
          props.row.submissions &&
          props.row.submissions.length > 0 &&
          props.row.feedback) ? _c('img', {
          attrs: {
            "src": require("../../../assets/img/play-button-small-green.png")
          },
          on: {
            "click": function($event) {
              _vm.playFeedback(props.row, true)
            }
          }
        }) : _c('img', {
          staticClass: "inactive",
          attrs: {
            "src": require("../../../assets/img/play-button-small-grey.png")
          }
        })]) : _vm._e()]
      }
    }])
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.feedbackPlaying === true),
      expression: "feedbackPlaying===true"
    }],
    staticClass: "feedback-lightbox",
    on: {
      "click": function($event) {
        _vm.stopFeedback()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-remove"
  }), _vm._v(" "), _c('div', {
    staticClass: "video-wrapper",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('poly-video', {
    ref: "videoPlayer",
    attrs: {
      "vjsOptions": _vm.videoPlayerOptions,
      "sources": _vm.videoPlayerSources
    },
    on: {
      "error": _vm.onVideoPlayerError,
      "loadedsource": _vm.onVideoPlayerLoadedSource
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-fa84f14c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/assignments-table/AssignmentsTable.vue
// module id = 2121
// module chunks = 2